"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const analytics_js_1 = require("@hh.ru/analytics-js");
/** Успешное создание после нажатия на кнопку:<ul><li>Сохранить и опубликовать в short резюме (репозиторий xhh)</li><li>Сохранить и продолжить в гибком резюме (репозиторий resume-profile-front)</li></ul> */
const resumeCreateAttemptExternal = ({ params }) => analytics_js_1.VendorAnalytics.eventToStorage("applicant", "resume-create-attempt", "", undefined, params);
exports.default = resumeCreateAttemptExternal;
